import { Inbox } from "lucide-react";

export function EmptyState({ icon: Icon = Inbox, title, description, action, testid }) {
    return (
        <div
            data-testid={testid || "empty-state"}
            className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-zinc-300 bg-zinc-50/40 px-6 py-12 text-center dark:border-zinc-700 dark:bg-zinc-900/40"
        >
            <span className="grid h-10 w-10 place-items-center rounded-full bg-brand-redSoft text-brand-redDeep dark:bg-brand-red/15 dark:text-brand-red">
                <Icon className="h-5 w-5" />
            </span>
            <div className="font-display text-base font-bold tracking-tight">{title}</div>
            {description && (
                <div className="max-w-md text-sm text-zinc-500">{description}</div>
            )}
            {action ? <div className="mt-2">{action}</div> : null}
        </div>
    );
}
